import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { SelfOrderShortOrderNumberUtil } from '@pos-common/services';

@Pipe({
  name: 'generateSelfOrderNumber'
})
export class GenerateSelfOrderNumberPipe implements PipeTransform {
  transform(invoiceId: string): string {
    return SelfOrderShortOrderNumberUtil(invoiceId);
  }
}

@NgModule({
  declarations: [GenerateSelfOrderNumberPipe],
  exports: [GenerateSelfOrderNumberPipe],
})
export class GenerateSelfOrderNumberPipeModule {}
